export class Park {
	public id: string;
	public name: string;
	public type_id: string;
	public prefix: string;
	
	constructor(server_obj: any) {
		this.prefix = 'prk_';
		if (server_obj) {
			this.id          = server_obj[this.prefix + 'id'];
			this.name     = server_obj[this.prefix + 'name'];
			this.type_id     = '' + server_obj[this.prefix + 'type_id'];
		}
	}
}
